<script>
  import { WaypointContent } from '../waypoints'

  export let waypoint
  export let active = false
</script>

{#if waypoint.hasContent()}
  {#if waypoint.hasWhen()}
    <p class='waypoint-date'>{waypoint.whenString}</p>
  {/if}
  <div class='stop-content with-marker'
    class:active
    class:compact={waypoint.isReading()}
    class:no-content={!waypoint.hasEntries() && !waypoint.hasImages()}
    class:entry-first={waypoint.hasEntries() && !waypoint.title}
    class:big-topgap={waypoint.hasWhen()}
  >
    <WaypointContent
      {waypoint}
      showDate={false}
      on:entry-click
    />
  </div>
{/if}

<style>
  .stop-content {
    --stop-content-padding: var(--spacer-lg);
    --stop-content-margin-top: 0;
    --stop-bg-color: var(--bg-color);
    --box-shadow-color: var(--color-grey);

    padding: var(--stop-content-padding);
    margin-top: var(--stop-content-margin-top);
    background: var(--stop-bg-color);
    border-radius: var(--border-radius-xs);

    box-shadow: var(--shadow) var(--box-shadow-color);
  }

  .stop-content.big-topgap {
    --stop-content-margin-top: var(--spacer-xxl);
  }

  .active {
    --box-shadow-color: var(--color-primary-xdark);
  }

  .waypoint-date {
     /* Set line height to ensure font aligns with ::before marker.
      * Date should always be on one line so it's fine :) */
    line-height: 0.9;
  }

  .waypoint-date::before {
    --waypoint-date-width: calc(var(--waypoint-padding-left) / 1.5);

    content: '';
    position: absolute;
    display: inline-block;
    left: 0;
    margin-top: calc(0.5em - 0.5 * var(--timeline-line-width));
    width: var(--waypoint-date-width);
    height: var(--timeline-line-width);
    background: var(--timeline-line-color);
  }

  .stop-content.with-marker::before {
    --stop-marker-size: 1rem;
    --stop-marker-offset-top: var(--font-size-md);

    content: '';
    position: absolute;
    display: inline-block;
    z-index: 10;
    left: calc(-0.5 * var(--stop-marker-size) - 0.5 * var(--timeline-line-width));
    margin-top: calc(var(--stop-marker-offset-top) - 0.6 * var(--stop-marker-size));
    width: var(--stop-marker-size);
    height: var(--stop-marker-size);

    border-radius: 50%;
    border: var(--timeline-line-width) solid var(--timeline-line-color);
    background: var(--color-white);
  }

  .stop-content.with-marker.compact::before {
    --stop-marker-size: 0.5rem;
  }

  .stop-content.no-content {
    --stop-bg-color: transparent;
    --box-shadow-color: transparent;
    padding-inline: 0;
  }

  .stop-content.with-marker.entry-first::before {
    --stop-marker-offset-top: var(--spacer-md); /* coincidence? */
  }

  .stop-content.active::before {
    background: var(--color-primary-dark);
  }
</style>
